export default function(document){
  const documentType = document && document.type ? document.type.split('::')[1].toLowerCase() : 'undefined';
  return documentType === 'undefined' ? 'document.jpg' : documentType + '.jpg';
}


// WEBPACK FOOTER //
// ./src/utils/getTransformedImageName.js